import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private languageSubject = new BehaviorSubject<string>(this.getInitialLanguage());
  language$ = this.languageSubject.asObservable();

  constructor() {}

  private getInitialLanguage(): string {
    // Implementa la lógica para obtener el idioma inicial
    return 'es'; // Ejemplo de idioma inicial
  }

  getLanguage(): string {
    return this.languageSubject.value;
  }

  setLanguage(language: string): void {
    this.languageSubject.next(language);
  }
}